<template>
  <div class="mapcontainer">
    <!-- <div style="width:100%;text-align:center;position:absolute;z-index:1000">            <span
        style="
         color: white; line-height: 80px; font-family: cursive; font-size:30px;
        "
      >
        YX-WRQ知识图谱平台</span
      ></div> -->
    <div class="pies" >
      <Pie></Pie>
    </div>
    <!-- <Map :url="configUrl" @onload="onMapload" /> -->
    <!-- <div v-if="showTilte" style="text-align:center;font-size:100px;color:red;position: absolute;z-index:999;top:40%;width:100%;">YX-WRQ知识图谱平台</div> -->

    <!-- <div class="charts" v-if="(showCharts || !searchResult) && !showTu">
      <Echart5></Echart5>
    </div> -->
  </div>
</template>

<script>
import userapi from "@/api/user";
// import * as mars3d from 'mars3d'
// import Map from "../components/mars3d/Map.vue";
// import Echart5 from "../components/charts/Echart5.vue";
import Pie from "@/components/charts/pie.vue";

export default {
  components: {
    Map,Pie
    // Echart5,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    return {
      configUrl: basePathUrl + "static/mapconfig/config.json", // 配置文件

      // 地图对象
      map: {},
    };
  },

  methods: {
    // 地图构造完成回调
    onMapload(map) {
      //console.log("地图构造完成");
      map.basemap = 2017;
      this.map = map;
      // this.startRotate();
      var lng = 94.35116;
      var lat = 29.6534;
      var datasuzu = [];
      for (var a = -10; a < 10; a++) {
        for (var b = -10; b < 10; b++) {
          datasuzu.push(lat + a * 0.4);
          datasuzu.push(lng + b * 0.4);
          datasuzu.push(Math.random()/20);
        }
      }
      var data = [["2015", datasuzu]];
      // mars3d.Util.fetchJson({ url: "//data.mars3d.cn/file/apidemo/population.json" })
      //   .then(function (data) {
      this.showData(data);
      // })
      // .catch(function (data) {
      //   console.log("ajax请求出错", data)
      // })
    },
    onUnmounted() {
      this.map = null;
    },
    // echart demo
    showData(data) {
      const heightScale = 2000000;

      // 创建矢量数据图层
      const graphicLayer = new mars3d.layer.GraphicLayer();
      this.map.addLayer(graphicLayer);

      // 在layer上绑定监听事件
      graphicLayer.on(mars3d.EventType.click, function (event) {
        //console.log("监听layer，单击了矢量对象", event);
      });

      // 在layer上绑定Popup弹窗
      graphicLayer.bindPopup(function (event) {
        const attr = event.graphic.attr || {};
        attr["类型"] = event.graphic.type;
        attr["来源"] = "我是layer上绑定的Popup";
        attr["备注"] = "我支持鼠标交互";

        return mars3d.Util.getTemplateHtml({
          title: "矢量图层",
          template: "all",
          attr: attr,
        });
      });

      for (let x = 0; x < 1; x++) {
        const series = data[x];
        const coordinates = series[1];

        // Now loop over each coordinate in the series and create
        for (let i = 0; i < coordinates.length; i += 3) {
          const latitude = coordinates[i];
          const longitude = coordinates[i + 1];
          const height = coordinates[i + 2];
          // Ignore lines of zero height.
          if (height == undefined || longitude == undefined || height === 0) {
            continue;
          }

          const color = Cesium.Color.fromHsl(0.6 - height * 10, 1.0, 0.5);
          const surfacePosition = Cesium.Cartesian3.fromDegrees(
            longitude,
            latitude,
            0
          );
          const heightPosition = Cesium.Cartesian3.fromDegrees(
            longitude,
            latitude,
            height * heightScale
          );

          const graphic = new mars3d.graphic.PolylineEntity({
            positions: [surfacePosition, heightPosition],
            style: {
              width: 4,
              color: color,
            },
            attr: { gdp: height },
          });
          graphicLayer.addGraphic(graphic);
        }
      }
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this;
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 });
      }
      this.stopRotate();

      this.previousTime = map.clock.currentTime.secondsOfDay;
      map.on(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    stopRotate() {
      const { map, mars3d } = this;
      map.off(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    map_onClockTick(clock) {
      const { map } = this;
      let spinRate = 150;
      let currentTime = map.clock.currentTime.secondsOfDay;
      let delta = (currentTime - this.previousTime) / 1000;
      this.previousTime = currentTime;
      map.scene.camera.rotateRight(-spinRate * delta);
    },
  },
};
</script>

<style  scoped>
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Earth3D.vue